module.exports = __webpack_public_path__ + "static/media/swimmyTwitter-600x314.82eef450.jpg";